// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"647759a6","452":"d33cddd6"}[chunkId] + ".chunk.css";
};